import(/* webpackMode: "eager" */ "/tmp/8de7096dc466719/app/[locale]/error.tsx");
